import { AxiosError } from 'axios';

import { unhandledRequest } from 'api/request';

export async function getToken() {
  const response = await unhandledRequest.get<{ ok: boolean; valid: boolean }>({
    url: `/integrations/journeys/settings/token/`,
  });
  return response.data;
}

export type ConnectType = {
  clientId: string;
  clientSecret: string;
};
export type ConnectError = AxiosError<{
  ok: boolean;
  error: string;
}>;

export async function connect(data: ConnectType) {
  const response = await unhandledRequest.post({
    url: `/integrations/journeys/settings/token/`,
    data,
  });
  return response.data;
}

export async function disconnect() {
  const response = await unhandledRequest.delete({
    url: `/integrations/journeys/settings/token/`,
  });
  return response.data;
}

export type ApplicantJourneyType = {
  id: string;
  journeyId: string;
  journeyTitle: string;
  journeyDescription: string;
  dateCreated: string;
  status: JourneyStatus;
  numActions: number;
  numCompleted: number;
  numHalted: number;
  numInProgress: number;
  numToBeStarted: number;
  workspaceId: string;
};

export type JourneyStatus = 'completed' | 'in_progress' | 'paused' | 'not_started';

export async function applicationJourneys(applicationId: number) {
  const response = await unhandledRequest.get<ApplicantJourneyType[]>({
    url: `/integrations/journeys/application/${applicationId}/journeys/`,
  });
  return response.data;
}

export type JourneyType = {
  shortId: string;
  description: string;
  title: string;
  hasPublishedJourney: boolean;
};

export async function journeys() {
  const response = await unhandledRequest.get<JourneyType[]>({
    url: `/integrations/journeys/list/`,
  });
  return response.data;
}

export type JourneyStatsType = {
  shortId: string;
  numNodeActions: number;
  numTravellers: number;
};

export async function statistics() {
  const response = await unhandledRequest.get<JourneyStatsType[]>({
    url: `/integrations/journeys/statistics/`,
  });
  return response.data;
}

export type AttributeType = {
  shortId: string;
  isActive: boolean;
  title: string;
  attributeType: AttributeTemplateType;
  isRequired: boolean;
  options?: string;
};
export async function companyTravellerAttributes() {
  const response = await unhandledRequest.get<AttributeType[]>({
    url: `/integrations/journeys/company-traveller-attributes/`,
  });
  return response.data;
}

export type AttributeTemplateType =
  | 'date'
  | 'text'
  | 'paragraph'
  | 'user'
  | 'single_select'
  | 'multi_select'
  | 'phone_number'
  | 'email'
  | 'file'
  | 'file_multi'
  | 'boolean';

export async function journeyTravellerAttributes(journeyId: string) {
  const response = await unhandledRequest.get<AttributeType[]>({
    url: `/integrations/journeys/journey-traveller-attributes/${journeyId}/`,
  });
  return response.data;
}

export type UserType = {
  shortId: string;
  name: string;
};
export async function users() {
  const response = await unhandledRequest.get<UserType[]>({
    url: `/integrations/journeys/users/`,
  });
  return response.data;
}

type Option = {
  shortId: string;
  value: string;
  label: string;
};
export type ListType = {
  shortId: string;
  name: string;
  options: Option[];
};
export async function list(listId: string) {
  const response = await unhandledRequest.get<ListType>({
    url: `/integrations/journeys/list/${listId}/`,
  });
  return response.data;
}

export type AddToJourneyType = {
  journey: string;
  applications: number[];
  name: string;
  email: string;
  phone: string;
  startJourney: boolean;
  attributes: { [key: string]: string | number[] };
};
export async function addToJourney(data: AddToJourneyType) {
  const response = await unhandledRequest.post({
    url: `/integrations/journeys/add-to-journey/`,
    data,
  });
  return response.data;
}

export async function removeFromJourney(applicationId: number, travellerJourneyId: string) {
  const response = await unhandledRequest.delete({
    url: `/integrations/journeys/application/${applicationId}/remove-journey/${travellerJourneyId}/`,
  });
  return response.data;
}
